(function () {
  'use strict';

  var SETTINGS = {
    revealMs: 900,
    hideMs: 700,
    revealEase: 'cubic-bezier(0.22, 1, 0.36, 1)',
  };

  var canvas = null;
  var shader = null;

  var fullImageWrap = null;
  var bgCanvas = null;
  var bgShader = null;
  var shapesWrap = null;
  var productsWrap = null;
  var revealed = false;
  var products = {};

  var activeContent = null;
  var contentTimers = [];
  var hideTimer = 0;
  var bgHideTimer = 0;
  var bgVisible = false;
  var boundResize = null;

  var BG_FADE_MS = 400;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobileMq = window.matchMedia('(max-width: 991px)');
  var finePointerMq = window.matchMedia('(hover: hover) and (pointer: fine)');

  var ICON = {
    plus: {
      a: { x1: 3.75, y1: 12, x2: 20.25, y2: 12 },
      b: { x1: 12, y1: 3.75, x2: 12, y2: 20.25 },
      neH: { x1: 20.25, y1: 12, x2: 20.25, y2: 12 },
      neV: { x1: 20.25, y1: 12, x2: 20.25, y2: 12 },
      swH: { x1: 3.75, y1: 12, x2: 3.75, y2: 12 },
      swV: { x1: 12, y1: 20.25, x2: 12, y2: 20.25 },
    },
    expand: {
      a: { x1: 13.5, y1: 10.5, x2: 19.5, y2: 4.5 },
      b: { x1: 10.5, y1: 13.5, x2: 4.5, y2: 19.5 },
      neH: { x1: 19.5, y1: 4.5, x2: 15, y2: 4.5 },
      neV: { x1: 19.5, y1: 4.5, x2: 19.5, y2: 9 },
      swH: { x1: 4.5, y1: 19.5, x2: 9, y2: 19.5 },
      swV: { x1: 4.5, y1: 19.5, x2: 4.5, y2: 15 },
    },
  };

  /* Figma 1032:187: a 106px circle centred in a 132x356 bottle marks the
     add-to-cart zone, so the radius is 0.4 of the bottle's width. Leaving takes
     a slightly wider circle than entering, so the edge cannot flicker. */
  var CART_R = 0.4015;
  var CART_CY = 0.4972;
  var CART_EXIT = 1.12;
  var CURSOR_LERP = 0.18;
  var TIP_REST_MS = 300;
  var LEAVE_GRACE_MS = 140;
  var BADGE_BASE = 32;
  var BADGE_SIZE = 32;
  var CURSOR_SHIFT = 6;
  var FOLLOW_GAP = 8;
  var VIEW_PAD = 8;
  var TIP_CART = 'Add to cart';
  var TIP_VIEW = 'View product';

  var cursorEl = null;
  var cursorBadge = null;
  var cursorTip = null;
  var cursorLines = null;
  var cursorMode = 'expand';
  var cursorShape = null;
  var cursorAt = null;
  var cursorTo = null;
  var cursorRaf = 0;
  var cursorLast = 0;
  var tipIdleTimer = 0;
  var leaveTimer = 0;
  var boundPointerMove = null;
  var boundPointerLeave = null;
  var boundDesktopClick = null;
  var boundCarouselNavClick = null;
  var boundCarouselPointerDown = null;
  var boundCarouselPointerUp = null;

  var CAROUSEL_PER = 3;
  var carousel = {
    wrap: null,
    viewport: null,
    track: null,
    nav: null,
    index: 0,
    dragX: 0,
    dragging: false,
  };

  function isMobile() {
    return mobileMq.matches;
  }

  /* From the dev's peak-input.js: the media query is only the opening guess, and
     the pointer actually in use decides. */
  function hasMouse() {
    return window.PeakInput ? window.PeakInput.canHover() : finePointerMq.matches;
  }

  function isDesktopHover() {
    return !isMobile() && hasMouse();
  }

  if (window.PeakInput) {
    window.PeakInput.onChange(function () {
      if (!isDesktopHover()) hideCursor();
    });
  }

  /* Kept in step with --home-cursor-scale so the snapped badge still centres on
     the zone, and the follow clamps still match the badge that is drawn. */
  function readBadgeSize() {
    if (!cursorEl) return;
    var scale = parseFloat(
      getComputedStyle(cursorEl).getPropertyValue('--home-cursor-scale')
    );
    BADGE_SIZE = BADGE_BASE * (scale > 0 ? scale : 1);
  }

  function queryCursorLines() {
    if (!cursorEl) return null;
    return {
      a: cursorEl.querySelector('.home-shape-cursor__line--a'),
      b: cursorEl.querySelector('.home-shape-cursor__line--b'),
      neH: cursorEl.querySelector('.home-shape-cursor__head--ne-h'),
      neV: cursorEl.querySelector('.home-shape-cursor__head--ne-v'),
      swH: cursorEl.querySelector('.home-shape-cursor__head--sw-h'),
      swV: cursorEl.querySelector('.home-shape-cursor__head--sw-v'),
    };
  }

  function applyIconAttrs(map) {
    if (!cursorLines) return;
    Object.keys(map).forEach(function (key) {
      var el = cursorLines[key];
      var pts = map[key];
      if (!el || !pts) return;
      el.setAttribute('x1', pts.x1);
      el.setAttribute('y1', pts.y1);
      el.setAttribute('x2', pts.x2);
      el.setAttribute('y2', pts.y2);
    });
  }

  function morphIcon(mode, instant) {
    var map = mode === 'cart' ? ICON.plus : ICON.expand;
    if (window.gsap && cursorLines) {
      Object.keys(cursorLines).forEach(function (key) {
        var el = cursorLines[key];
        if (el) window.gsap.killTweensOf(el);
      });
    }
    if (instant || prefersReducedMotion || !window.gsap || !cursorLines) {
      applyIconAttrs(map);
      return;
    }
    var dur = 0.28;
    var ease = 'power3.inOut';
    Object.keys(map).forEach(function (key) {
      var el = cursorLines[key];
      if (!el) return;
      window.gsap.to(el, { attr: map[key], duration: dur, ease: ease });
    });
  }

  function setCursorMode(mode, instant) {
    var changed = cursorMode !== mode;
    cursorMode = mode;
    if (cursorEl) {
      cursorEl.classList.toggle('is-expand', mode !== 'cart');
      if (mode === 'cart') cursorEl.classList.remove('is-tip-hidden');
    }
    if (cursorTip) cursorTip.textContent = mode === 'cart' ? TIP_CART : TIP_VIEW;
    if (changed || instant) morphIcon(mode, instant);
  }

  /* The whole catalogue is sold out, so the cart zone cannot be reached on the
     real storefront. ?cart=demo treats the bottles as in stock for internal
     testing — only the cursor behaviour; a real add still goes to Shopify and
     is refused. */
  var DEMO_CART = /[?&]cart=demo(&|$)/.test(location.search);

  function shapeAllowsCart(shape) {
    if (!shape) return false;
    if (DEMO_CART) return true;
    return shape.getAttribute('data-available') === 'true';
  }

  function cartZone(shape) {
    var rect = shape.getBoundingClientRect();
    return {
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height * CART_CY,
      r: rect.width * CART_R,
    };
  }

  function modeForPoint(shape, clientX, clientY) {
    if (!shapeAllowsCart(shape)) return 'expand';
    var zone = cartZone(shape);
    if (!zone.r) return 'expand';
    var reach = cursorMode === 'cart' ? zone.r * CART_EXIT : zone.r;
    return Math.hypot(clientX - zone.x, clientY - zone.y) <= reach ? 'cart' : 'expand';
  }

  function bottleInsetX(t) {
    var waists = [0.27, 0.5, 0.72];
    var tightness = 0;
    var i;
    for (i = 0; i < waists.length; i++) {
      tightness = Math.max(tightness, 1 - Math.min(1, Math.abs(t - waists[i]) / 0.12));
    }
    return 4 + tightness * 22;
  }

  function clamp(n, min, max) {
    if (max < min) return (min + max) / 2;
    return Math.min(max, Math.max(min, n));
  }

  function placeFlipped(originX, originY, w, h, minX, minY, maxX, maxY) {
    var x = originX;
    var y = originY;
    if (x + w > maxX) x = originX - w;
    if (y + h > maxY) y = originY - h;
    return {
      x: clamp(x, minX, maxX - w),
      y: clamp(y, minY, maxY - h),
    };
  }

  function showCursor() {
    if (!cursorEl) return;
    cursorEl.hidden = false;
    cursorEl.classList.add('is-visible');
  }

  function hideCursor() {
    if (!cursorEl) return;
    clearTimeout(leaveTimer);
    cursorEl.classList.remove('is-visible');
    cursorEl.hidden = true;
    cursorShape = null;
    clearTimeout(tipIdleTimer);
    cursorEl.classList.remove('is-tip-hidden');
    stopCursorLoop();
    cursorAt = null;
    cursorTo = null;
    setCursorMode('expand', true);
  }

  /* The badge free-follows the pointer, but inside the cart zone it parks on
     the zone's centre and stays there until the pointer leaves. Both are the
     same target, eased frame by frame, so entering and leaving read as one
     movement rather than a jump. */
  function badgeTarget(clientX, clientY, shape, mode) {
    var rect = shape.getBoundingClientRect();

    if (mode === 'cart') {
      var zone = cartZone(shape);
      return { x: zone.x - BADGE_SIZE / 2, y: zone.y - BADGE_SIZE / 2 };
    }

    var t = rect.height ? (clientY - rect.top) / rect.height : 0.5;
    var insetX = bottleInsetX(t);
    return placeFlipped(
      clientX + CURSOR_SHIFT,
      clientY + CURSOR_SHIFT,
      BADGE_SIZE,
      BADGE_SIZE,
      rect.left + insetX,
      rect.top + 4,
      rect.right - insetX,
      rect.bottom - 4
    );
  }

  function paintCursor() {
    if (!cursorBadge || !cursorAt) return;

    cursorBadge.style.transform =
      'translate3d(' + cursorAt.x + 'px,' + cursorAt.y + 'px,0)';

    if (!cursorTip) return;

    var tipW = cursorTip.offsetWidth || 0;
    var tipH = cursorTip.offsetHeight || 0;
    var viewMinX = VIEW_PAD;
    var viewMinY = VIEW_PAD;
    var viewMaxX = window.innerWidth - VIEW_PAD;
    var viewMaxY = window.innerHeight - VIEW_PAD;
    var originX = cursorAt.x + BADGE_SIZE + FOLLOW_GAP;
    if (originX + tipW > viewMaxX) originX = cursorAt.x - FOLLOW_GAP - tipW;

    var tip = placeFlipped(
      originX,
      cursorAt.y + (BADGE_SIZE - tipH) / 2,
      tipW,
      tipH,
      viewMinX,
      viewMinY,
      viewMaxX,
      viewMaxY
    );

    cursorTip.style.transform =
      'translate3d(' + tip.x + 'px,' + tip.y + 'px,0)';
  }

  /* "View product" is for a pointer that has stopped to look: it stays out of
     the way while the mouse is moving and fades in once it rests. The snapped
     "Add to cart" label is always up. */
  function tipOnMove() {
    if (!cursorEl) return;
    clearTimeout(tipIdleTimer);
    if (cursorMode === 'cart') {
      cursorEl.classList.remove('is-tip-hidden');
      return;
    }
    cursorEl.classList.add('is-tip-hidden');
    tipIdleTimer = setTimeout(function () {
      if (cursorEl) cursorEl.classList.remove('is-tip-hidden');
    }, TIP_REST_MS);
  }

  function stopCursorLoop() {
    if (cursorRaf) cancelAnimationFrame(cursorRaf);
    cursorRaf = 0;
    cursorLast = 0;
  }

  function cursorFrame(now) {
    cursorRaf = requestAnimationFrame(cursorFrame);
    if (!cursorAt || !cursorTo) return;

    var dt = cursorLast ? Math.min(100, now - cursorLast) : 16.7;
    cursorLast = now;

    var k = 1 - Math.pow(1 - CURSOR_LERP, dt / 16.667);
    cursorAt.x += (cursorTo.x - cursorAt.x) * k;
    cursorAt.y += (cursorTo.y - cursorAt.y) * k;

    if (Math.abs(cursorTo.x - cursorAt.x) < 0.05
      && Math.abs(cursorTo.y - cursorAt.y) < 0.05) {
      cursorAt.x = cursorTo.x;
      cursorAt.y = cursorTo.y;
      stopCursorLoop();
    }
    paintCursor();
  }

  function moveCursor(clientX, clientY, shape, instant) {
    if (!cursorEl || !cursorBadge || !shape) return;

    cursorTo = badgeTarget(clientX, clientY, shape, cursorMode);

    if (instant || prefersReducedMotion || !cursorAt) {
      cursorAt = { x: cursorTo.x, y: cursorTo.y };
      stopCursorLoop();
      paintCursor();
      return;
    }
    if (!cursorRaf) cursorRaf = requestAnimationFrame(cursorFrame);
  }

  /* The bottles are clipped to their outline, so a pointer sliding along an
     edge keeps falling out of the silhouette at the waists — the cursor used to
     blink out three times on the way down. The row itself carries the listener
     instead, and the bottle is chosen by its box. */
  function shapeAtPoint(clientX, clientY) {
    var shapes = shapesWrap
      ? shapesWrap.querySelectorAll('.shape-wrapper[data-id]')
      : [];
    for (var i = 0; i < shapes.length; i++) {
      var r = shapes[i].getBoundingClientRect();
      if (clientX >= r.left && clientX <= r.right
        && clientY >= r.top && clientY <= r.bottom) return shapes[i];
    }
    return null;
  }

  function onShapePointerMove(e) {
    if (!isDesktopHover()) return;
    var shape = e.currentTarget.classList
      && e.currentTarget.classList.contains('shape-wrapper')
      ? e.currentTarget
      : shapeAtPoint(e.clientX, e.clientY);
    if (!shape) {
      scheduleHide();
      return;
    }
    clearTimeout(leaveTimer);
    var first = !!(cursorEl && cursorEl.hidden);
    cursorShape = shape;
    setCursorMode(modeForPoint(shape, e.clientX, e.clientY), first);
    tipOnMove();
    moveCursor(e.clientX, e.clientY, shape, first);
    showCursor();
  }

  function scheduleHide() {
    clearTimeout(leaveTimer);
    leaveTimer = setTimeout(hideCursor, LEAVE_GRACE_MS);
  }

  function onShapePointerLeave(e) {
    if (!isDesktopHover()) return;
    var next = e.relatedTarget;
    if (next && next.closest && next.closest('.shape-wrapper')) return;
    scheduleHide();
  }

  function submitHomeCart(shape) {
    if (!shapeAllowsCart(shape)) return false;
    var formId = shape.getAttribute('data-form-id');
    var form = formId ? document.getElementById(formId) : null;
    if (form) {
      var btn = form.querySelector('[type="submit"]');
      if (btn && !btn.disabled && btn.getAttribute('aria-disabled') !== 'true') {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(btn);
        else btn.click();
        return true;
      }
    }

    var variantId = shape.getAttribute('data-variant-id');
    var addUrl = window.routes && window.routes.cart_add_url;
    if (!variantId || !addUrl) return false;

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');
    fetch(addUrl, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: body,
    }).then(function () {
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'home-shape' });
      }
    }).catch(function () { /* ignore */ });
    return true;
  }

  function onDesktopShapeClick(e) {
    if (!isDesktopHover()) return;
    var shape = e.target.closest && e.target.closest('a.shape-wrapper[data-id]');
    if (!shape) return;
    if (cursorMode !== 'cart' || !shapeAllowsCart(shape)) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    submitHomeCart(shape);
  }

  function carouselShapes() {
    if (!carousel.track) return [];
    return Array.prototype.slice.call(carousel.track.querySelectorAll('.shape-wrapper[data-id]'));
  }

  function carouselMax() {
    return Math.max(0, carouselShapes().length - CAROUSEL_PER);
  }

  function carouselGap() {
    if (!carousel.track) return 0;
    return parseFloat(window.getComputedStyle(carousel.track).gap) || 0;
  }

  function carouselStep() {
    var shapes = carouselShapes();
    if (!shapes.length) return 0;
    return shapes[0].getBoundingClientRect().width + carouselGap();
  }

  function carouselWrapInnerWidth() {
    if (!carousel.wrap) return 0;
    var cs = window.getComputedStyle(carousel.wrap);
    return Math.max(
      0,
      carousel.wrap.clientWidth
        - (parseFloat(cs.paddingLeft) || 0)
        - (parseFloat(cs.paddingRight) || 0)
    );
  }

  function sizeCarouselViewport() {
    if (!carousel.viewport) return;
    var shapes = carouselShapes();
    if (!shapes.length) return;
    var bottleW = shapes[0].getBoundingClientRect().width;
    if (bottleW < 8) return;
    var visible = Math.min(CAROUSEL_PER, shapes.length);
    var width = bottleW * visible + carouselGap() * (visible - 1);
    var max = carouselWrapInnerWidth();
    if (max > 0 && width > max) width = max;
    width = Math.round(width * 100) / 100;
    if (carousel.wrap) {
      carousel.wrap.style.setProperty('--home-shape-w', Math.round(bottleW * 100) / 100 + 'px');
      carousel.wrap.style.setProperty('--home-shape-row', width + 'px');
    }
    carousel.viewport.style.width = width + 'px';
  }

  function renderCarouselDots() {
    if (!carousel.nav) return;
    var total = carouselShapes().length;
    var slides = carouselMax() + 1;
    if (total <= 3 || slides < 2) {
      carousel.nav.hidden = true;
      return;
    }
    carousel.nav.hidden = false;
    var dotsWrap = carousel.nav.querySelector('.home-shapes-nav__dots');
    if (!dotsWrap) {
      dotsWrap = document.createElement('div');
      dotsWrap.className = 'home-shapes-nav__dots';
      carousel.nav.insertBefore(dotsWrap, carousel.nav.firstChild);
    }
    var html = '';
    var i;
    for (i = 0; i < slides; i++) {
      html += '<button type="button" class="home-shapes-nav__dot" data-index="' + i + '" aria-label="Go to slide ' + (i + 1) + '"></button>';
    }
    dotsWrap.innerHTML = html;
    if (!carousel.nav.querySelector('.home-shapes-nav__count')) {
      var count = document.createElement('span');
      count.className = 'home-shapes-nav__count text-small';
      count.setAttribute('aria-live', 'polite');
      carousel.nav.appendChild(count);
    }
  }

  function updateCarouselDots() {
    if (!carousel.nav) return;
    var dots = carousel.nav.querySelectorAll('.home-shapes-nav__dot');
    Array.prototype.forEach.call(dots, function (dot, i) {
      var on = i === carousel.index;
      dot.classList.toggle('is-active', on);
      if (on) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
    var countEl = carousel.nav.querySelector('.home-shapes-nav__count');
    if (countEl) {
      countEl.textContent = (carousel.index + 1) + '/' + (carouselMax() + 1);
    }
  }

  function applyCarousel(animate) {
    if (!carousel.track) return;
    sizeCarouselViewport();
    var max = carouselMax();
    carousel.index = Math.max(0, Math.min(max, carousel.index));
    var x = carouselStep() * carousel.index;
    if (animate === false) carousel.track.style.transition = 'none';
    carousel.track.style.transform = 'translate3d(' + -x + 'px,0,0)';
    if (animate === false) {
      void carousel.track.offsetWidth;
      carousel.track.style.transition = '';
    }
    updateCarouselDots();
    carouselShapes().forEach(function (shape, i) {
      var visible = i >= carousel.index && i < carousel.index + CAROUSEL_PER;
      shape.tabIndex = visible ? 0 : -1;
      shape.setAttribute('aria-hidden', visible ? 'false' : 'true');
    });
  }

  function goCarousel(delta) {
    if (!carousel.track) return;
    var next = Math.max(0, Math.min(carouselMax(), carousel.index + delta));
    if (next === carousel.index) return;
    carousel.index = next;
    hide();
    hideCursor();
    applyCarousel(true);
  }

  function onCarouselNavClick(e) {
    var dot = e.target.closest && e.target.closest('.home-shapes-nav__dot');
    if (!dot) return;
    var next = Number(dot.getAttribute('data-index'));
    if (isNaN(next) || next === carousel.index) return;
    carousel.index = next;
    hide();
    hideCursor();
    applyCarousel(true);
  }

  function onCarouselPointerDown(e) {
    if (e.pointerType === 'mouse') return;
    carousel.dragging = true;
    carousel.dragX = e.clientX;
  }

  function onCarouselPointerUp(e) {
    if (!carousel.dragging) return;
    carousel.dragging = false;
    var dx = e.clientX - carousel.dragX;
    if (Math.abs(dx) < 40) return;
    goCarousel(dx < 0 ? 1 : -1);
  }

  function initCarousel() {
    carousel.wrap = document.querySelector('.product-shapes-wrap[data-home-carousel]');
    if (!carousel.wrap) return;
    carousel.viewport = carousel.wrap.querySelector('.product-shapes-viewport');
    carousel.track = carousel.wrap.querySelector('.product-shapes-track');
    carousel.nav = carousel.wrap.querySelector('.home-shapes-nav');
    if (!carousel.track) return;

    boundCarouselNavClick = onCarouselNavClick;
    boundCarouselPointerDown = onCarouselPointerDown;
    boundCarouselPointerUp = onCarouselPointerUp;

    renderCarouselDots();
    if (carousel.nav) carousel.nav.addEventListener('click', boundCarouselNavClick);
    if (carousel.viewport) {
      carousel.viewport.addEventListener('pointerdown', boundCarouselPointerDown);
    }
    window.addEventListener('pointerup', boundCarouselPointerUp);
    window.addEventListener('pointercancel', boundCarouselPointerUp);
    applyCarousel(false);
    requestAnimationFrame(function () { applyCarousel(false); });
  }

  function destroyCarousel() {
    if (carousel.nav && boundCarouselNavClick) {
      carousel.nav.removeEventListener('click', boundCarouselNavClick);
    }
    if (carousel.viewport && boundCarouselPointerDown) {
      carousel.viewport.removeEventListener('pointerdown', boundCarouselPointerDown);
    }
    if (boundCarouselPointerUp) {
      window.removeEventListener('pointerup', boundCarouselPointerUp);
      window.removeEventListener('pointercancel', boundCarouselPointerUp);
    }
    boundCarouselNavClick = null;
    boundCarouselPointerDown = null;
    boundCarouselPointerUp = null;
    carousel.wrap = null;
    carousel.viewport = null;
    carousel.track = null;
    carousel.nav = null;
    carousel.index = 0;
    carousel.dragging = false;
  }

  /* ---------- product content / image / shapes ---------- */

  function clearContentTimers() {
    contentTimers.forEach(clearTimeout);
    contentTimers = [];
  }

  function showContentBodyText(content) {
    if (prefersReducedMotion || !window.animateBodyText) return;

    content.querySelectorAll('[data-animate="body"]').forEach(function (el) {
      var delay = (Number(el.dataset.delay) || 0) / 1000;

      el.style.opacity = '';
      el.style.visibility = '';

      if (el._bodyLineTimeline) {
        window.playBodyText(el, delay);
        return;
      }

      window.animateBodyText(el, {
        useScrollTrigger: false,
        autoPlay: false,
        onReady: function () {
          window.playBodyText(el, delay);
        },
      });
    });
  }

  function resetContentBodyText(content, hideImmediately) {
    if (!window.resetBodyText) return;

    content.querySelectorAll('[data-animate="body"]').forEach(function (el) {
      window.resetBodyText(el);

      if (hideImmediately) {
        el.style.opacity = '0';
        el.style.visibility = 'hidden';
      }
    });
  }

  function clearContentBodyTextStyles(content) {
    content.querySelectorAll('[data-animate="body"]').forEach(function (el) {
      el.style.opacity = '';
      el.style.visibility = '';
    });
  }

  function showContent(content) {
    if (activeContent && activeContent !== content) {
      deactivateContent(activeContent);
    }
    activeContent = content;
    if (!content) return;

    content.classList.add('active');
    clearContentBodyTextStyles(content);
    void content.offsetWidth;

    content.querySelectorAll('[data-animation]').forEach(function (item) {
      var delay = prefersReducedMotion ? 0 : Number(item.dataset.delay) || 0;
      contentTimers.push(setTimeout(function () {
        item.classList.add('in-view');
      }, delay));
    });

    showContentBodyText(content);
  }

  function deactivateContent(content) {
    content.classList.remove('active');
    content.querySelectorAll('[data-animation]').forEach(function (item) {
      item.classList.remove('in-view');
    });
    resetContentBodyText(content);
  }

  function showImage(imageId) {
    if (!fullImageWrap || !imageId || !bgShader) return;

    clearTimeout(bgHideTimer);
    fullImageWrap.classList.add('visible');
    fullImageWrap.setAttribute('aria-hidden', 'false');
    if (bgCanvas) bgCanvas.classList.add('is-visible');

    var img = document.getElementById(imageId);
    if (!img) return;

    if (!bgVisible) {
      bgShader.setImageElement(img).then(function () {
        bgShader.start();
        bgVisible = true;
      });
      return;
    }

    bgShader.crossfadeTo(img, prefersReducedMotion ? 0 : BG_FADE_MS);
  }

  function hideImage() {
    if (!fullImageWrap) return;

    clearTimeout(bgHideTimer);

    var fadeMs = prefersReducedMotion ? 0 : BG_FADE_MS;

    if (bgCanvas) bgCanvas.classList.remove('is-visible');

    bgHideTimer = setTimeout(function () {
      fullImageWrap.classList.remove('visible');
      fullImageWrap.setAttribute('aria-hidden', 'true');
      if (bgShader) bgShader.stop();
      bgVisible = false;
    }, fadeMs);
  }

  function setActiveShape(id) {
    if (!shapesWrap) return;
    shapesWrap.classList.add('has-active');
    shapesWrap.querySelectorAll('.shape-wrapper').forEach(function (shape) {
      shape.classList.toggle('active', shape.dataset.id === id);
    });
  }

  function clearActiveShapes() {
    if (!shapesWrap) return;
    shapesWrap.classList.remove('has-active');
    shapesWrap.querySelectorAll('.shape-wrapper.active').forEach(function (shape) {
      shape.classList.remove('active');
    });
  }

  /* ---------- reveal / hide ---------- */

  function reveal(id) {
    var p = products[id];
    if (!p || !canvas || !shader) return;

    clearTimeout(hideTimer);
    clearTimeout(bgHideTimer);
    clearContentTimers();

    shader.setConfig(p.grad);
    shader.start();

    canvas.dataset.product = id;
    canvas.style.transitionDuration = prefersReducedMotion ? '0ms' : SETTINGS.revealMs + 'ms';
    canvas.style.opacity = '1';
    revealed = true;
    if (productsWrap) productsWrap.classList.add('is-active');

    if (activeContent === p.content) {
      p.content.querySelectorAll('[data-animation]').forEach(function (item) {
        item.classList.remove('in-view');
      });
      resetContentBodyText(p.content);
      void p.content.offsetWidth;
    }

    showContent(p.content);
    showImage(p.image);
    setActiveShape(id);
  }

  function hide() {
    if (!canvas || !revealed) return;

    clearContentTimers();
    revealed = false;
    if (productsWrap) productsWrap.classList.remove('is-active');
    hideImage();
    clearActiveShapes();

    if (activeContent) {
      activeContent.querySelectorAll('[data-animation]').forEach(function (item) {
        item.classList.remove('in-view');
      });
      resetContentBodyText(activeContent, true);
    }

    canvas.style.transitionDuration = prefersReducedMotion ? '0ms' : SETTINGS.hideMs + 'ms';
    canvas.style.opacity = '0';

    hideTimer = setTimeout(function () {
      if (activeContent) {
        clearContentBodyTextStyles(activeContent);
        activeContent.classList.remove('active');
        activeContent = null;
      }
      if (shader) shader.stop();
      if (bgShader) bgShader.stop();
    }, prefersReducedMotion ? 0 : SETTINGS.hideMs);
  }

  function init() {
    canvas = document.querySelector('#gradCanvas');
    fullImageWrap = document.querySelector('.full-imagewrapper');
    shapesWrap = document.querySelector('.product-shapes-wrap');
    productsWrap = document.querySelector('.products-wrapper');

    if (!canvas || !window.GradShader) return;

    if (fullImageWrap && window.BgShader) {
      bgCanvas = fullImageWrap.querySelector('#bgCanvas');
      var srcImgEl = fullImageWrap.querySelector('#bgSrc') || fullImageWrap.querySelector('.bg-src');

      if (bgCanvas && srcImgEl) {
        bgShader = window.BgShader.create({
          canvas: bgCanvas,
          srcImg: srcImgEl,
          noiseImg: '#noiseSrc',
        });
      }
    }

    shader = window.GradShader.create(canvas, { edgeVertical: isMobile });

    canvas.style.opacity = '0';
    canvas.style.transitionProperty = 'opacity';
    canvas.style.transitionTimingFunction = SETTINGS.revealEase;

    cursorEl = document.querySelector('.home-shape-cursor');
    if (cursorEl && cursorEl.parentNode !== document.body) {
      document.body.appendChild(cursorEl);
    }
    cursorBadge = cursorEl ? cursorEl.querySelector('.home-shape-cursor__badge') : null;
    cursorTip = cursorEl ? cursorEl.querySelector('.home-shape-cursor__tip') : null;
    cursorLines = queryCursorLines();
    readBadgeSize();
    cursorMode = '';
    setCursorMode('expand', true);

    boundPointerMove = onShapePointerMove;
    boundPointerLeave = onShapePointerLeave;
    boundDesktopClick = onDesktopShapeClick;
    document.addEventListener('click', boundDesktopClick, true);

    boundResize = function () {
      readBadgeSize();
      shader.resize();
      if (bgShader) bgShader.resize();
      if (!isDesktopHover()) hideCursor();
      applyCarousel(false);
    };
    window.addEventListener('resize', boundResize);

    initCarousel();

    document.querySelectorAll('.shape-wrapper[data-id]').forEach(function (shape) {
      var id = shape.dataset.id;
      products[id] = {
        grad: typeof window.GradShader.configFromElement === 'function'
          ? window.GradShader.configFromElement(shape)
          : {},
        content: document.getElementById(id),
        image: shape.dataset.image || '',
      };

      shape.addEventListener('mouseenter', function () {
        if (!isDesktopHover()) return;
        reveal(id);
      });
      shape.addEventListener('mouseleave', function () {
        if (!isDesktopHover()) return;
        hide();
      });
      shape.addEventListener('pointerenter', boundPointerMove);
      shape.addEventListener('pointermove', boundPointerMove);
      shape.addEventListener('click', function (e) {
        if (isDesktopHover()) return;
        if (shape.classList.contains('active')) return;
        e.preventDefault();
        reveal(id);
      });
    });

    var row = shapesWrap ? shapesWrap.querySelector('.product-shapes-track') : null;
    if (row) {
      row.addEventListener('pointermove', boundPointerMove);
      row.addEventListener('pointerleave', boundPointerLeave);
    }

    document.querySelectorAll('.product-back').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (isDesktopHover()) return;
        e.preventDefault();
        hide();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.ProductHover = {
    init: init,
    reveal: reveal,
    hide: hide,
    products: products,
    settings: SETTINGS,
    isCartMode: function () { return cursorMode === 'cart'; },
    // init/destroy can be re-invoked if the products-wrapper markup is recreated.
    destroy: function () {
      clearTimeout(hideTimer);
      clearTimeout(bgHideTimer);
      clearContentTimers();
      hideCursor();
      destroyCarousel();
      document.querySelectorAll('.shape-wrapper[data-id]').forEach(function (shape) {
        if (boundPointerMove) {
          shape.removeEventListener('pointerenter', boundPointerMove);
          shape.removeEventListener('pointermove', boundPointerMove);
        }
        if (boundPointerLeave) shape.removeEventListener('pointerleave', boundPointerLeave);
      });
      if (boundDesktopClick) {
        document.removeEventListener('click', boundDesktopClick, true);
      }
      if (shader) shader.stop();
      if (bgShader) bgShader.stop();
      if (boundResize) {
        window.removeEventListener('resize', boundResize);
        boundResize = null;
      }
      canvas = null;
      shader = null;
      bgShader = null;
      bgCanvas = null;
      fullImageWrap = null;
      shapesWrap = null;
      productsWrap = null;
      cursorEl = null;
      cursorBadge = null;
      cursorTip = null;
      cursorLines = null;
      cursorShape = null;
      boundPointerMove = null;
      boundPointerLeave = null;
      boundDesktopClick = null;
      activeContent = null;
      revealed = false;
      bgVisible = false;
      products = {};
    },
  };
})();
